import { render, staticRenderFns } from "./VxModal.vue?vue&type=template&id=486db1cd&"
import script from "./VxModal.vue?vue&type=script&lang=ts&"
export * from "./VxModal.vue?vue&type=script&lang=ts&"
import style0 from "./VxModal.vue?vue&type=style&index=0&id=486db1cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports